var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.615 112.45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Experian_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 260",
    fill: "none",
    d: "M0 0h347.615v112.45H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 350",
    clipPath: "url(#Experian_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 219",
    d: "M54.945 26.479H42.227a6.821 6.821 0 01-6.882-6.879V6.882A6.9 6.9 0 0142.227 0h12.718a6.9 6.9 0 016.882 6.882V19.6a6.821 6.821 0 01-6.882 6.879",
    fill: "#406eb3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 220",
    d: "M21.93 55.059H7.7a7.691 7.691 0 01-7.7-7.7V33.013a7.767 7.767 0 017.7-7.7h14.347a7.691 7.691 0 017.7 7.7V47.36a7.717 7.717 0 01-7.816 7.7",
    fill: "#632678"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 221",
    d: "M20.647 84.804h-8.749a4.68 4.68 0 01-4.666-4.666v-8.749a4.68 4.68 0 014.666-4.666h8.749a4.68 4.68 0 014.666 4.666v8.749a4.68 4.68 0 01-4.666 4.666",
    fill: "#982881"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 222",
    d: "M44.093 112.45H33.712a5.6 5.6 0 01-5.6-5.6V96.47a5.6 5.6 0 015.6-5.6h10.381a5.6 5.6 0 015.6 5.6v10.381a5.528 5.528 0 01-5.6 5.6",
    fill: "#ba2f7d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 223",
    d: "M82.004 31.728h-7.116a3.884 3.884 0 01-3.849-3.849v-7.116a3.884 3.884 0 013.849-3.849h7.116a3.884 3.884 0 013.849 3.849v7.116a3.738 3.738 0 01-3.849 3.849",
    fill: "#ba2f7d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 224",
    d: "M239.015 36.511a4.083 4.083 0 100-8.165 4.084 4.084 0 100 8.165",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 225",
    d: "M88.186 80.605a3.185 3.185 0 01-2.8 1.4 3.423 3.423 0 01-1.866-.467 3.487 3.487 0 01-1.516-2.916 2.678 2.678 0 01.467-1.633l9.565-15.048-9.565-15.048a2.916 2.916 0 01-.467-1.633 3.326 3.326 0 011.633-2.916 3.292 3.292 0 011.75-.467 3.539 3.539 0 012.917 1.4l7.815 12.365 7.932-12.365a3.392 3.392 0 012.916-1.4 3.292 3.292 0 011.75.467 3.326 3.326 0 011.633 2.916 2.678 2.678 0 01-.467 1.633l-9.565 15.048 9.565 15.048a2.678 2.678 0 01.467 1.633 3.34 3.34 0 01-1.516 2.916 3.694 3.694 0 01-1.866.467 3.326 3.326 0 01-2.8-1.4l-7.933-12.249z",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 226",
    d: "M122.365 46.426a20.589 20.589 0 110 30.679v17.614a3.443 3.443 0 01-3.383 3.266 3.529 3.529 0 01-3.383-3.266V44.793a3.443 3.443 0 013.383-3.266 3.363 3.363 0 013.383 3.266zm13.648 1.633a13.765 13.765 0 1013.765 13.765 13.5 13.5 0 00-13.765-13.765",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 227",
    d: "M215.218 58.094v20.644a3.443 3.443 0 01-3.383 3.266 3.363 3.363 0 01-3.383-3.266V44.794a3.443 3.443 0 013.383-3.266 3.511 3.511 0 013.383 3.15 17.191 17.191 0 0110.265-3.384 3.453 3.453 0 110 6.882c-5.249.117-10.265 1.983-10.265 9.915",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 228",
    d: "M239.015 41.527a3.363 3.363 0 00-3.383 3.266v34.062a3.443 3.443 0 003.383 3.266 3.529 3.529 0 003.383-3.266V44.793a3.443 3.443 0 00-3.383-3.266",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 229",
    d: "M282.408 44.794a3.443 3.443 0 013.383-3.266 3.529 3.529 0 013.383 3.266v34.061a3.443 3.443 0 01-3.383 3.266 3.363 3.363 0 01-3.383-3.266v-1.633a20.809 20.809 0 01-13.765 5.249 20.589 20.589 0 110-41.177 20.809 20.809 0 0113.765 5.249zm-13.765 30.8a13.765 13.765 0 10-13.765-13.77 13.642 13.642 0 0013.765 13.765",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 230",
    d: "M323.823 58.558a10.809 10.809 0 00-10.615-10.615c-5.483 0-10.615 2.216-10.615 10.265v20.647a3.443 3.443 0 01-3.383 3.266 3.363 3.363 0 01-3.383-3.266V44.794a3.443 3.443 0 013.383-3.266 3.511 3.511 0 013.383 3.15 17.127 17.127 0 0110.5-3.383c9.215 0 17.5 7.232 17.5 16.331v21.23a3.443 3.443 0 01-3.383 3.266 3.363 3.363 0 01-3.383-3.266z",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 231",
    d: "M80.021 60.658c-.117-10.5-9.449-19.364-20.53-19.364a20.589 20.589 0 100 41.177 20.192 20.192 0 0014.348-5.832 3.534 3.534 0 001.166-2.566 3.463 3.463 0 00-3.383-3.379 3.611 3.611 0 00-2.678 1.4 12.66 12.66 0 01-9.332 3.616 13.6 13.6 0 01-13.648-11.2h31.141a.429.429 0 00.35-.117 4.108 4.108 0 002.566-3.733m-20.53-12.6a13.583 13.583 0 0113.065 9.565H46.31a13.621 13.621 0 0113.181-9.565",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 232",
    d: "M202.736 60.658c-.117-10.5-9.565-19.364-20.53-19.364a20.589 20.589 0 100 41.177 20.192 20.192 0 0014.348-5.832 3.534 3.534 0 001.166-2.566 3.463 3.463 0 00-3.383-3.383 3.611 3.611 0 00-2.683 1.4 12.66 12.66 0 01-9.332 3.616 13.6 13.6 0 01-13.648-11.2h31.379a4.381 4.381 0 002.683-3.849m-20.53-12.6a13.583 13.583 0 0113.065 9.565h-26.246a13.621 13.621 0 0113.181-9.565",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 233",
    d: "M337.817 82.122a.551.551 0 01-.583-.583v-5.717h-1.283a.583.583 0 110-1.166h3.733a.583.583 0 110 1.166h-1.283v5.716a.551.551 0 01-.583.583",
    fill: "#26478d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 234",
    d: "M344.466 82.122c-.35 0-.467-.233-.583-.467l-1.633-4.666v4.549a.584.584 0 11-1.167 0v-6.065a.8.8 0 01.817-.817.877.877 0 01.817.583l1.633 4.783 1.633-4.783a.877.877 0 01.817-.583.8.8 0 01.817.817v6.066a.584.584 0 01-1.167 0v-4.55c-.233.7-.583 1.866-.933 2.8-.583 1.866-.7 1.866-.7 1.866.117.35-.117.467-.35.467",
    fill: "#26478d"
  }))));
}
export default SvgExperian;